const events = [
  {
    title: "Microsoft",
    type:"2-months Internship",
    desc: "Microsoft Corporation is an American multinational technology corporation which produces computer software, consumer electronics, personal computers, and related services. Its best-known software products are the Microsoft Windows line of operating systems, the Microsoft Office suite, and the Internet Explorer and Edge web browsers. Its flagship hardware products are the Xbox video game consoles and the Microsoft Surface lineup of touchscreen personal computers. Microsoft ranked No. 21 in the 2020 Fortune 500 rankings of the largest United States corporations by total revenue;[3] it was the world's largest software maker by revenue as of 2016.[4] It is one of the Big Five American information technology companies, alongside Google, Amazon, Apple, and Meta.",
    link:"https://www.microsoft.com/en-in",
    deadline: "25-04-2022, 10.00 AM",
    post: "software developer, web developer"
  },
  {
    title: "JPMC",
    type:"2-months Internship",
    desc: "J.P. Morgan is a global leader in financial services, offering solutions to the world's most important corporations, governments and institutions in more than 100 countries. As announced in early 2018, JPMorgan Chase will deploy $1.75 billion in philanthropic capital around the world by 2023. We also lead volunteer service activities for employees in local communities by utilizing our many resources, including those that stem from access to capital, economies of scale, global reach and expertise.We aim to be the most respected financial services firm in the world, serving corporations and individuals in more than 100 countries.",
    link:"https://www.jpmorgan.com/",
    deadline: "25-04-2022, 10.00 AM",
    post: "software developer, web developer"
  },
  {
    title: "Amazon",
    type:"FTE",
    desc: "This year, Amazon launched its first private brand with products all having third-party certifications featured in the Climate Pledge Friendly program. The Amazon Aware line features thoughtfully designed, affordable, everyday essentials across apparel, home, beauty, and other categories, all made from materials such as recycled polyester, organic cotton, and bio-based ingredients with certifications specific to product type.",
    link:"https://www.amazon.in/",
    deadline: "25-04-2022, 10.00 AM",
    post: "software developer, web developer"
  },
  {
    title: "Goldman Sachs",
    type:"2-months Internship, FTE",
    desc: "The Goldman Sachs Group, Inc. is a leading global investment banking, securities and investment management firm that provides a wide range of financial services to a substantial and diversified client base that includes corporations, financial institutions, governments and individuals. Founded in 1869, the firm is headquartered in New York and maintains offices in all major financial centers around the world.Goldman Sachs brings people, capital and ideas together to help our clients and the communities we serve.",
    link:"https://www.goldmansachs.com/",
    deadline: "25-04-2022, 10.00 AM",
    post: "software developer, web developer"
  },
  {
    title: "Google",
    type:"Internship",
    desc: "Our mission is to organise the world’s information and make it universally accessible and useful.Part of any journey is celebrating the progress made along the way. We invite you to take a closer look at how inspiring women — at Google and beyond — are creating a more equitable future where all people can be exactly who and what they want to be.",
    link:"https://about.google/",
    deadline: "25-04-2022, 10.00 AM",
    post: "software developer, web developer"
  },
  {
    title: "Samsung",
    type:"FTE, 2-moths internship",
    desc: "Samsung Electronics constantly reinvents the future. We explore the unknown to discover technologies to help people all over the world lead happier, healthier lives.We create a culture of infinite possibilities. The deep trust and loyalty of our customers drives us to continually grow and lead innovation.",
    link:"https://www.samsung.com/",
    deadline: "25-04-2022, 10.00 AM",
    post: "software developer, web developer"
  },
];

export default events;
